export default "__VITE_ASSET__CDlZTCLc__"